import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// const ROIReportSubmitted = () => {
  
// };

// export default ROIReportSubmitted;


const StoreROI = () => {
  const { roiId, submittedID } = useParams();
  const masterId = submittedID;


  useEffect(() => {
    // Check if master ID exists in local storage
    const storedMasterId = localStorage.getItem('roi_master_id');

    if (storedMasterId) {
      // Master ID exists, add child data
      console.log('Master ID exists:', storedMasterId);
      addChildData(storedMasterId);
    } else {
      // Master ID does not exist, insert master data, add child data, and store master ID in local storage
      console.log('Master ID does not exist. Inserting master data...');
      insertMasterData(masterId).then((newMasterId) => {
        console.log('New Master ID inserted:', newMasterId);
        localStorage.setItem('roi_master_id', newMasterId);
        addChildData(newMasterId);
      });
    }
  }, []);

  const addChildData = (masterId) => {
    // Function to add child data with the given master ID
    console.log('Adding child data with master ID:', masterId);
    // Add your logic to add child data here
  };

  const insertMasterData = async (masterId) => {
    // Function to insert master data and return the master ID
    console.log('Inserting master data with ID:', masterId);
    // Add your logic to insert master data here
    // Return the master ID (simulated with a Promise for this example)
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(masterId); // Simulate an API call that returns the master ID
      }, 1000);
    });
  };

  return (
    <>
    <div>
      <h1>ROI Master ID Storage</h1>
      <p>Check the console for storage and insertion details.</p>
    </div>
    
    <div>
      <h1>ROI Report Submitted</h1>
      <p>ROI ID: {roiId}</p>
      <p>Submitted ID: {submittedID}</p>
    </div>
    </>
  );
};

export default StoreROI;